var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSportCategories = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / List / default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M5.14282 3.28568H21.1428",
    stroke: "#738A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy",
    d: "M5.14282 8.42862H18.8571",
    stroke: "#738A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 2",
    d: "M5.14282 18.7143H18.8571",
    stroke: "#738A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5 Copy 2_2",
    d: "M5.14282 13.5714H21.1428",
    stroke: "#738A9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2",
    cx: 1.28571,
    cy: 13.5715,
    r: 1.28571,
    fill: "#738A9E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2_2",
    cx: 1.28571,
    cy: 18.7143,
    r: 1.28571,
    fill: "#738A9E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.28571,
    cy: 3.28571,
    r: 1.28571,
    fill: "#738A9E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy",
    cx: 1.28571,
    cy: 8.42854,
    r: 1.28571,
    fill: "#738A9E"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSportCategories, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sportCategories.5d5af000.svg";
export { ForwardRef as ReactComponent };